import React, { useEffect, useState } from "react";

const RELEASE = "2026.08";

export default function EmployeeExperience() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const key = `ebek_whats_new_${RELEASE}`;
    if ((localStorage.getItem("crm_token") || localStorage.getItem("token")) && !localStorage.getItem(key)) setOpen(true);
    const showAbout = () => setOpen(true);
    window.addEventListener("ebek:about-open", showAbout);
    return () => window.removeEventListener("ebek:about-open", showAbout);
  }, []);
  const close = () => { localStorage.setItem(`ebek_whats_new_${RELEASE}`, "seen"); setOpen(false); };
  return <>
    {open && <div style={backdrop} role="dialog" aria-modal="true" aria-label="What's new in Ebek One"><div style={modal}>
      <div style={kicker}>What’s new · v{RELEASE}</div>
      <h2 style={{margin:"8px 0",color:"#172033"}}>Field work, but smoother ✨</h2>
      <ul style={list}><li>Visits and photos can queue safely when the network drops.</li><li>Faster issue reporting through HRMS Helpdesk.</li><li>Clearer visit, lead and follow-up confirmations.</li></ul>
      <div style={privacy}><strong>GPS privacy:</strong> CRM uses location for field visits, distance and audit checks during configured working activity. It is not intended for personal or off-duty tracking.</div>
      <button onClick={close} style={button}>Got it, let’s go</button>
    </div></div>}
  </>;
}
const backdrop={position:"fixed",inset:0,zIndex:10001,background:"rgba(15,23,42,.55)",display:"grid",placeItems:"center",padding:18};
const modal={width:"min(480px,100%)",background:"#fff",borderRadius:18,boxShadow:"0 25px 80px #0005",padding:22,fontFamily:"Inter,system-ui,sans-serif"};
const kicker={fontSize:12,fontWeight:900,color:"#0f9f9a",letterSpacing:1,textTransform:"uppercase"};
const list={color:"#475569",lineHeight:1.65,paddingLeft:20};
const privacy={background:"#f8fafc",borderRadius:12,padding:12,color:"#475569",fontSize:12,lineHeight:1.55};
const button={width:"100%",marginTop:16,border:0,borderRadius:11,background:"#0f9f9a",color:"#fff",padding:"11px 14px",fontWeight:900,cursor:"pointer"};
